import { useState } from "react";
import FormInput from "../../components/FormInput";
import { endpoints } from "../../helpers/Endpoints";
import { api } from "../../helpers/apiCore";
import { Alert, Button, Spinner } from "react-bootstrap";
import errorInfoIcon from "../../assets/icons/error_info.svg";
import { Wallet } from "./UserWalletDetails";
import successMark from "../../assets/icons/success_mark.svg";


interface DebitWalletProps {
	formatAmount: (amount: number | any) => string;
	walletDetail: Wallet | null;
	hideDebitForm: () => void
}

const DebitWallet = ({ walletDetail, formatAmount, hideDebitForm }: DebitWalletProps) => {

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [formData, setFormData] = useState({
		walletId: "",
		amount: "",
		description: "",
	});
	const [showForm, setShowForm] = useState(true);
	const [showConfirmation, setShowConfirmation] = useState(false);
	const [showSuccess, setShowSuccess] = useState(false);

	const handleWalletDebit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const debitData = {
			...formData,
			walletId: walletDetail?.walletId,
		};
		setIsSubmitting(true);
		try {
			api.setAuthorization(api.getLoggedInUser());
			const response = await api.create(endpoints.debitUserWallet, debitData);
			const responseData = response.data
			setShowConfirmation(false);
			setShowSuccess(true)
		} catch (error: any) {
			const message = error?.response?.data?.message || 'Unable to debit wallet, please try again';
			setError(message);
			setShowAlert(true);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setError(null);
		const { name, value } = e.target;
		setFormData((prevFormData) => ({
			...prevFormData,
			[name]: value,
		}));
	};

	const handleConfirmationStep = () => {
		setShowForm(false)
		setShowConfirmation(true)
	}

	return (
		<>
			<div className="detail-section">
				<form onSubmit={handleWalletDebit}>
					{showForm && (
						<>
							<FormInput
								label="Amount"
								name="amount"
								type="number"
								value={formData.amount}
								onChange={handleChange}
								className="mb-2"
							/>
							<FormInput
								label="Description"
								name="description"
								type="text"
								value={formData.description}
								onChange={handleChange}
								className="mb-2"
							/>
							<Button onClick={handleConfirmationStep} className="proceed-debit mt-2 text-center" style={{ margin: 'auto' }}>Proceed</Button>
						</>
					)}

					{showConfirmation && (
						<div className="text-center">
							<span className="mb-3">Debit {formatAmount(formData.amount)} from {`${walletDetail?.user?.firstName} ${walletDetail?.user?.lastName}`}?</span>
							<div className="mt-2">
								<Button className="cancel-debit" onClick={hideDebitForm}>Cancel</Button>
								<Button type="submit" disabled={isSubmitting || !formData.amount || !formData.description} className="proceed-debit">
									{isSubmitting ? <Spinner animation="border" size="sm" /> : "Confirm debit"}
								</Button>
							</div>
						</div>
					)}
				</form>

				{showAlert && (
					<>
						<Alert
							variant='danger'
							className="alert-error text-center mt-2"
						>
							{error && <img src={errorInfoIcon} alt="error" />}
							{error}
						</Alert>
					</>
				)}

				{showSuccess && (
					<div className="text-center" style={{ padding: '15px' }}>
						<img src={successMark} alt="success" className="mb-3"/>
						<p>Successfully debitted {formatAmount(formData.amount)} from {`${walletDetail?.user?.firstName} ${walletDetail?.user?.lastName}`}'s wallet.</p>
					</div>
				)}

			</div>
		</>
	)
};

export default DebitWallet;